<template>
<v-dialog
  style="border-radius: 10px;"
  v-model="dialog"
  width="500"
>
  <v-card  class="px-2 py-3">
    <v-card-title class="pa-1">
      <span class="font-weight-bold headline wrld_subtitle--text">
        {{$t('organizations.add_managed_organization')}}
      </span>
    </v-card-title>
    <v-card-text class="pa-1">
      <v-container class="pb-0">
        <v-form v-model="isValid" ref="createOrganizationForm">
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <v-text-field class="wrld_subtitle--text" :label="$t('companies.name')" v-model="name"
              :rules="[Required]"
              >

              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <v-text-field class="wrld_subtitle--text" :label="$t('companies.ico')" v-model="regNo"
              :rules="[Required]"
              >

              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <v-text-field class="wrld_subtitle--text" :label="$t('companies.dic')" v-model="vatNo"
              :rules="[Required]"
              >

              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <LocationAutocomplete
      :key="locationAutocompleteKey"
      @address="(newAddress) => address = newAddress"
      @coordinates="(newCoordinates) => coordinates = newCoordinates"
      @is-valid="(validLocation) => isValidLocation = validLocation"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="wrld-background elevation-1" @click="handleCancelOrganization">
        <span color="wrld_subtitle--text">{{$t('buttons.cancel')}}</span>
      </v-btn>
      <v-btn v-if="!isLoadingAddOrganization" color="accent elevation-1" class="ml-5 mr-4" :disabled="computedFormValidation"  @click="handleCreateOrganization">{{$t('buttons.create')}}</v-btn>
      <v-btn v-else color="accent elevation-1" class="ml-5 mr-4" disabled>
        <v-progress-circular
          size="20"
          width="3"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import { uuid } from 'vue-uuid'
import { organizationService, locationService } from '@/_services'
import { mapActions } from 'vuex'
import { Required, CountryCodeRule } from '@/plugins/form-validations.js'
import LocationAutocomplete from '@/components/organizations/locations/LocationAutocomplete'

export default {
  name: 'AddOrganization',
  components: {
    LocationAutocomplete
  },
  props: {
    openMenu: { type: Boolean, default: false }
  },
  data () {
    return {
      Required,
      CountryCodeRule,
      locationAutocompleteKey: uuid.v1(),
      dialog: false,
      isValid: false,
      isValidLocation: false,
      isLoadingAddOrganization: false,
      name: null,
      regNo: null,
      vatNo: null,
      address: {
        street: null,
        streetNo: null,
        city: null,
        countryCode: null,
        postalCode: null
      },
      coordinates: {
        lat: null,
        lng: null
      }
    }
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar'
    }),
    handleCreateOrganization () {
      this.isLoadingAddOrganization = true
      this.requestAddress = { ...this.address }
      this.requestAddress.streetNo = this.address.streetNo
      this.requestAddress.postalCode = this.address.postalCode
      organizationService.addManagedOrganization({ name: this.name, regNo: this.regNo, vatNo: this.vatNo, address: this.requestAddress }).then((response) => {
        return locationService.createLocation({
          organization: response.id,
          type: 'HQ',
          coordinates: this.coordinates,
          name: 'HQ',
          address: this.address
        })
      }).then((response) => {
        const newOrganization = {
          name: this.name,
          regNo: this.regNo,
          vatNo: this.vatNo,
          address: this.address,
          hq: {
            address: this.address,
            coordinates: this.coordinates,
            type: 'HQ',
            name: 'HQ'
          }
        }
        this.$refs['createOrganizationForm'].reset()
        this.$emit('organization-added', newOrganization)
        this.$nextTick(() => {
          this.dialog = false
        })
        this.showSnackbar({ message: this.$t('snackbars.organization_created'), color: 'success' })
      }).catch((error) => {
        this.showSnackbar({ message: this.$i18n.t('snackbars.error'), color: 'error' })
        console.error(error)
      }).finally(() => {
        this.isLoadingAddOrganization = false
      })
    },
    handleCancelOrganization () {
      this.$refs['createOrganizationForm'].reset()
      this.locationAutocompleteKey = uuid.v1()
      this.dialog = false
    }
  },
  computed: {
    computedFormValidation () {
      return !(this.isValid && this.isValidLocation)
    }
  },
  watch: {
    openMenu: {
      handler: function (val, oldVal) {
        this.dialog = val
      }
    },
    dialog: {
      handler: function (val, oldVal) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
